import { render } from "./NavBar.vue?vue&type=template&id=02007f50&bindings={\"mobileMenuShown\":\"setup\",\"toggleMobileMenu\":\"setup\",\"links\":\"setup\"}"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"
script.render = render

export default script